import { render, staticRenderFns } from "./SendMessageModal.vue?vue&type=template&id=5f2db0c2&"
import script from "./SendMessageModal.vue?vue&type=script&lang=js&"
export * from "./SendMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports